import type { DebugBridge } from './DebugBridge';

export interface PanelEntry {
  name: string;
  el: HTMLElement;
  collapsed: boolean;
}

export class DebugPanel {
  readonly el: HTMLDivElement;
  private panels: PanelEntry[] = [];
  private contentEl: HTMLDivElement;
  private toggleBtn: HTMLButtonElement;
  private visible: boolean = false;

  constructor(bridge?: DebugBridge) {
    void bridge;

    this.el = document.createElement('div');
    this.el.className = 'debug-panel';

    const header = document.createElement('div');
    header.className = 'debug-panel-header';

    const title = document.createElement('span');
    title.textContent = 'Debug Tools';
    title.className = 'debug-panel-title';
    header.appendChild(title);

    this.toggleBtn = document.createElement('button');
    this.toggleBtn.textContent = '▶';
    this.toggleBtn.className = 'debug-panel-toggle';
    this.toggleBtn.onclick = () => this.toggle();
    header.appendChild(this.toggleBtn);

    this.el.appendChild(header);

    this.contentEl = document.createElement('div');
    this.contentEl.className = 'debug-panel-content';
    this.contentEl.style.display = 'none';
    this.el.appendChild(this.contentEl);
  }

  addPanel(name: string, el: HTMLElement): void {
    const wrapper = document.createElement('div');
    wrapper.className = 'debug-sub-panel';

    const panelHeader = document.createElement('div');
    panelHeader.className = 'debug-sub-panel-header';

    const label = document.createElement('span');
    label.textContent = name;
    label.className = 'debug-sub-panel-label';

    const collapseBtn = document.createElement('button');
    collapseBtn.textContent = '−';
    collapseBtn.className = 'debug-sub-panel-collapse';

    panelHeader.appendChild(label);
    panelHeader.appendChild(collapseBtn);
    wrapper.appendChild(panelHeader);
    wrapper.appendChild(el);

    const entry: PanelEntry = { name, el, collapsed: false };

    collapseBtn.onclick = () => {
      entry.collapsed = !entry.collapsed;
      el.style.display = entry.collapsed ? 'none' : '';
      collapseBtn.textContent = entry.collapsed ? '+' : '−';
    };

    this.panels.push(entry);
    this.contentEl.appendChild(wrapper);
  }

  removePanel(name: string): void {
    const idx = this.panels.findIndex(p => p.name === name);
    if (idx === -1) return;
    const entry = this.panels[idx];
    const wrapper = entry.el.parentElement;
    if (wrapper && wrapper.parentElement) {
      wrapper.parentElement.removeChild(wrapper);
    }
    this.panels.splice(idx, 1);
  }

  show(): void {
    this.visible = true;
    this.contentEl.style.display = '';
    this.toggleBtn.textContent = '▼';
  }

  hide(): void {
    this.visible = false;
    this.contentEl.style.display = 'none';
    this.toggleBtn.textContent = '▶';
  }

  toggle(): void {
    if (this.visible) {
      this.hide();
    } else {
      this.show();
    }
  }

  isVisible(): boolean {
    return this.visible;
  }

  render(): HTMLElement {
    return this.el;
  }

  destroy(): void {
    if (this.el.parentNode) {
      this.el.parentNode.removeChild(this.el);
    }
  }
}
